import { useEffect, useState } from 'react';

declare const __BUILD_ID__: string;

/** Новый билд на сервере — мягкий баннер, никаких внезапных перезагрузок:
 *  кассир дожмёт чек и обновится сам. */
export function UpdateBanner() {
  const [fresh, setFresh] = useState(false);
  useEffect(() => {
    // Касса с диска (exe): обновления приходят новым установщиком,
    // а /version.json на file:// не существует — молчим сразу
    if (window.location.protocol === 'file:') return;
    const check = async () => {
      try {
        const r = await fetch(`/version.json?ts=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const d = (await r.json()) as { build?: string };
        if (d.build && d.build !== __BUILD_ID__) setFresh(true);
      } catch { /* офлайн — молчим */ }
    };
    const t = setInterval(() => void check(), 5 * 60_000);
    void check();
    return () => clearInterval(t);
  }, []);
  if (!fresh) return null;
  return (
    <div className="update-banner" role="status">
      Вышло обновление
      <button onClick={() => window.location.reload()}>Обновить</button>
    </div>
  );
}
